var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.0537109,
    width: 31.3225,
    height: 27.6338,
    rx: 9,
    fill: "#626687",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4861 18.7836L16.4111 18.8586L16.3286 18.7836C12.7661 15.5511 10.4111 13.4136 10.4111 11.2461C10.4111 9.74609 11.5361 8.62109 13.0361 8.62109C14.1911 8.62109 15.3161 9.37109 15.7136 10.3911H17.1086C17.5061 9.37109 18.6311 8.62109 19.7861 8.62109C21.2861 8.62109 22.4111 9.74609 22.4111 11.2461C22.4111 13.4136 20.0561 15.5511 16.4861 18.7836ZM19.7861 7.12109C18.4811 7.12109 17.2286 7.72859 16.4111 8.68109C15.5936 7.72859 14.3411 7.12109 13.0361 7.12109C10.7261 7.12109 8.91113 8.92859 8.91113 11.2461C8.91113 14.0736 11.4611 16.3911 15.3236 19.8936L16.4111 20.8836L17.4986 19.8936C21.3611 16.3911 23.9111 14.0736 23.9111 11.2461C23.9111 8.92859 22.0961 7.12109 19.7861 7.12109Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/Fav.3ca2489ffab7ee7f4496b8f37c69e317.svg";
export { ForwardRef as ReactComponent };